import * as moment from 'moment';
import 'moment/locale/de';
import * as React from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import ButtonGroup from 'reactstrap/lib/ButtonGroup';
import Modal from 'reactstrap/lib/Modal';
import ModalBody from 'reactstrap/lib/ModalBody';
import ModalFooter from 'reactstrap/lib/ModalFooter';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import FAIcon from 'src/components/fAIcon/FAIcon';
import { TR } from 'src/TextRes';
import {
    Accounting,
    AccountingLoadMineParams,
    ApiAccountingLoadmine,
    ApiBookingsAdd,
    ApiBookingsChangeOption,
    ApiBookingsReject,
    ApiBookingsUnreject,
    ApiCourseLoadminimal,
    Booking,
    BookingCreateParams,
    BookingOption,
    Course,
    CourseBookings,
    CourseMinimal,
    CoursesLoadMinimalResult,
    ServerResponse,
} from '../../api';
import TableBoxForCPBookingsNew from '../../components/cpBookingRequests/TableBoxForCPBookingsNew';
import TableBoxForCPBookingsProofed from '../../components/cpBookingRequests/TableBoxForCPBookingsProofed';
import TableBoxForNewParticipant from '../../components/cpBookingRequests/TableBoxForNewParticipant';
import CPHeaderLoggedIn from '../../components/cpHeaderLoggedIn/CPHeaderLoggedIn';
import { FieldsetWarningBox } from '../../components/fieldsetWarningBox/FieldsetWarningBox';
import Footer from '../../components/footer/Footer';
import NetworkOverlay from '../../components/networkOverlay/NetworkOverlay';
import { IThConfig } from '../../components/sortableTh/SortableTh';
import './CPBookings.css';

interface CPBookingsProps {
    match: { params: { month: string } };
}

interface CPBookingsState {
    showBookings: boolean;
    saveError: boolean;
    listData: Accounting;
    saveData: Accounting;
    coursesMinimal: CoursesLoadMinimalResult;
    commissionSum: number;
    loading: boolean;
    searchParams: AccountingLoadMineParams;
    serverResponse?: ServerResponse;
    showAddNewBookingOverlay: string;
    sum: number;
    weDontHaveData: boolean;
    invoiceStatusName: string;
    rejectModalOpen: boolean;
    rejectBooking?: Booking;
    rejectOption: string;
    rejectPrice: string;
}

export enum InvoiceState {
    Invoiced = 'invoiced',
    Virtual = 'virtual',
}

export default class CPBookings extends React.PureComponent<CPBookingsProps, CPBookingsState> {
    private renderTHeadLineArraysNew: IThConfig[] = [
        { name: 'Teilnehmer', width: '35%' },
        { name: 'Buchungdatum', width: '15%' },
        { name: 'Buchungsoptionen', width: '15%' },
        { name: 'Kursgebühr', width: '15%' },
        { name: 'Vermittlungsgebühr', width: '10%' },
        { name: 'Stornieren', width: '10%' },
    ];
    private renderTHeadLineArraysNotNew: IThConfig[] = [
        { name: 'Teilnehmer', width: '45%' },
        { name: 'Buchungdatum', width: '15%' },
        { name: 'Buchungsoptionen', width: '15%' },
        { name: 'Kursgebühr', width: '15%' },
        { name: 'Vermittlungsgebühr', width: '10%' },
    ];
    constructor(props: CPBookingsProps) {
        super(props);
        this.state = {
            commissionSum: 0,
            coursesMinimal: {
                Courses: [],
            },
            invoiceStatusName: '',
            listData: {
                Appointments: 0,
                Bookings: 0,
                CommissionSum: 0,
                CourseBookings: [],
                CourseProviderCommission: 0,
                CourseProviderID: '',
                CourseProviderName: '',
                CourseProviderVat: 'true',
                ID: '',
                InsertDate: {},
                InvoiceDate: {},
                InvoiceState: InvoiceState.Virtual,
                Month: '',
                Sum: 0,
                UpdateDate: {},
            },
            loading: true,
            saveData: {
                Appointments: 0,
                Bookings: 0,
                CommissionSum: 0,
                CourseBookings: [],
                CourseProviderCommission: 0,
                CourseProviderID: '',
                CourseProviderName: '',
                CourseProviderVat: 'true',
                ID: '',
                InsertDate: {},
                InvoiceDate: {},
                InvoiceState: InvoiceState.Virtual,
                Month: '',
                Sum: 0,
                UpdateDate: {},
            },
            saveError: false,
            searchParams: {
                Month: '',
            },
            serverResponse: undefined,
            showAddNewBookingOverlay: '',
            showBookings: true,
            sum: 0,
            weDontHaveData: false,
            rejectModalOpen: false,
            rejectBooking: undefined,
            rejectOption: 'teilnehmer',
            rejectPrice: '',
        };
    }

    public componentDidMount() {
        let now = moment().format('YYYY-MM');
        if (this.props.match.params.month) {
            now = this.props.match.params.month;
        }
        this.setState({ searchParams: { Month: now } }, this.getBookingRequests);
    }

    public render() {
        const { listData, saveData, searchParams, loading, serverResponse, weDontHaveData } = this.state;

        const toDayMoment = Number.parseInt(moment().format('D').toString(), 10);
        const finalizationMoment = Math.floor(Number.parseInt(moment().endOf('month').format('D').toString(), 10) / 2);

        // anzeigen, wenn der monat der offen ist vor dem aktuellen monat ist und es noch keine invoice gibt.
        const showWarning =
            listData.InvoiceState === InvoiceState.Virtual && moment(listData.Month).endOf('month').isBefore(moment());

        return (
            <NetworkOverlay loading={loading} serverResponse={serverResponse}>
                <CPHeaderLoggedIn />
                {!loading && (
                    <Container>
                        {false && !weDontHaveData && showWarning && (
                            <FieldsetWarningBox
                                legendTitel={'Bitte prüfen'}
                                td2Content={
                                    <>
                                        <h2>
                                            {TR.cPBookings_still} {finalizationMoment - toDayMoment}{' '}
                                            {TR.cPBookings_days}
                                        </h2>
                                        <h5>{TR.cPBookings_until_automatic}</h5>
                                    </>
                                }
                                td3Content={<h6 style={{ textAlign: 'left' }}>{TR.cPBookings_help_text}</h6>}
                                fieldsetClass="mt-1 mb-3"
                                td1Width="10%"
                                td2Width="20%"
                                td3Width="70%"
                            />
                        )}
                        <Row className="mt-4">
                            <Col md={7}>
                                <h4>
                                    <b>
                                        {TR.cPBookings_bookings_for} {moment(searchParams.Month).format('MMMM YYYY')}
                                        {this.state.showBookings ? ' (nicht abgerechnet)' : ' (abgerechnet)'}
                                    </b>
                                </h4>
                            </Col>
                            <Col md={5} className="text-right">
                                <ButtonGroup>
                                    <Button
                                        size="sm"
                                        color="danger"
                                        onClick={() => {
                                            this.setState({ loading: true });
                                            const newSearchParams = searchParams;
                                            newSearchParams.Month = moment(searchParams.Month)
                                                .subtract(1, 'months')
                                                .format('YYYY-MM')
                                                .toString();
                                            this.setState({ searchParams: newSearchParams });
                                            this.changeValue('Month', searchParams.Month, true);
                                        }}
                                    >
                                        <span>{TR.cPBookings_month_back}</span>
                                    </Button>
                                    <Button
                                        size="sm"
                                        color="danger"
                                        onClick={() => {
                                            const newSearchParams = searchParams;
                                            newSearchParams.Month = moment(searchParams.Month)
                                                .add(1, 'months')
                                                .format('YYYY-MM')
                                                .toString();
                                            this.setState({ searchParams: newSearchParams, loading: true });
                                            this.changeValue('Month', searchParams.Month, true);
                                        }}
                                    >
                                        <span>{TR.cPBookings_month_forward}</span>
                                    </Button>
                                </ButtonGroup>
                            </Col>
                        </Row>
                        <Row className="mt-1">
                            <Col md={12}>
                                <Button
                                    size="sm"
                                    color="danger"
                                    onClick={() => {
                                        this.setState(
                                            { showBookings: !this.state.showBookings },
                                            this.getBookingRequests
                                        );
                                    }}
                                >
                                    {this.state.showBookings
                                        ? TR.cPBookings_show_invoiced
                                        : TR.cPBookings_open_bookings}
                                </Button>
                            </Col>
                        </Row>
                        {weDontHaveData && listData.InvoiceState !== InvoiceState.Virtual && (
                            <div className="mt-5 text-center h3">{TR.cPBookings_no_invoicing}</div>
                        )}
                        {listData.InvoiceState === InvoiceState.Virtual && saveData.CourseBookings.length === 0 && (
                            <div className="mt-4 mb-4 text-center h3">{TR.cPBookings_no_bookings}</div>
                        )}
                        {!weDontHaveData &&
                            listData.InvoiceState === InvoiceState.Virtual &&
                            saveData.CourseBookings.sort((a: CourseBookings, b: CourseBookings) => {
                                return moment(a.CourseDate).isBefore(moment(b.CourseDate)) ? -1 : 1;
                            }).map((obj: CourseBookings, index: number) => {
                                const cminimal = this.state.coursesMinimal.Courses.find((c: Course) => {
                                    return c.ID === obj.CourseID;
                                });

                                return (
                                    <React.Fragment key={(index + 1) * 1000 + (obj.CourseName + 1)}>
                                        <Row className="mt-4">
                                            <Col>
                                                <h5 className="mb-3">
                                                    {obj.CourseName}
                                                    {!!cminimal && cminimal.RefNo && (
                                                        <span>&nbsp;&nbsp;({cminimal.RefNo})</span>
                                                    )}{' '}
                                                    | <strong>Termin:</strong>{' '}
                                                    {obj.Bookings &&
                                                        moment(obj.CourseDate).add('hour', 3).format('DD.MM.YYYY')}
                                                </h5>
                                                <TableBoxForCPBookingsNew
                                                    listData={obj.Bookings}
                                                    cpVat={listData.CourseProviderVat}
                                                    courseBookingOptions={this.getBookingOptions(obj.CourseID)}
                                                    renderTHeadLine={this.renderTHeadLineArraysNew}
                                                    rejectBooking={(b: Booking) => this.openRejectModal(b)}
                                                    unrejectBooking={(b: Booking) => this.unrejectBooking(b)}
                                                    setBookingOption={(b: Booking, bk: BookingOption) =>
                                                        this.changeBookingOption(b, bk)
                                                    }
                                                    // changeBooking={(a: Booking[]) => {
                                                    //     mySaveData.CourseBookings[index].Bookings = a;
                                                    //     this.setState(
                                                    //         {
                                                    //             saveData: Object.assign(saveData, mySaveData)
                                                    //         },
                                                    //         this.saveDataCalculator
                                                    //     );
                                                    // }}
                                                />
                                            </Col>
                                        </Row>
                                        <br />
                                    </React.Fragment>
                                );
                            })}
                        {!weDontHaveData &&
                            listData.InvoiceState !== InvoiceState.Virtual &&
                            listData.CourseBookings.map((obj: CourseBookings, index: number) => {
                                const cminimal = this.state.coursesMinimal.Courses.find((c: Course) => {
                                    return c.ID === obj.CourseID;
                                });

                                return (
                                    <React.Fragment key={(index + 1) * 1000 + (obj.CourseName + 1)}>
                                        <Row className="mt-4">
                                            <Col>
                                                <h5 className="mb-3">
                                                    {obj.CourseName}
                                                    &nbsp;am&nbsp;
                                                    {obj.Bookings && moment(obj.CourseDate).format('DD.MM.YYYY')}
                                                    {!!cminimal && cminimal.RefNo && (
                                                        <span>&nbsp;&nbsp;({cminimal.RefNo})</span>
                                                    )}
                                                </h5>
                                                <TableBoxForCPBookingsProofed
                                                    listData={obj.Bookings}
                                                    renderTHeadLine={this.renderTHeadLineArraysNotNew}
                                                />
                                            </Col>
                                        </Row>
                                        <br />
                                    </React.Fragment>
                                );
                            })}

                        {!weDontHaveData && saveData.CourseBookings.length > 0 && (
                            <>
                                {listData.InvoiceState === InvoiceState.Virtual && (
                                    <Row className="mt-2">
                                        <Col md={10}>{TR.cPBookings_options}</Col>
                                    </Row>
                                )}
                                <Row className="mt-2">
                                    <Col md={10} />
                                    <Col md={2} className="text-right">
                                        {this.formatNumber(this.state.sum)}
                                        &nbsp;€&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;
                                        <strong>
                                            {this.formatNumber(this.state.commissionSum)}
                                            &nbsp;€
                                        </strong>
                                    </Col>
                                </Row>
                            </>
                        )}
                        {listData.InvoiceState === InvoiceState.Virtual && (
                            <>
                                <Row className="mt-5 overlay-container">
                                    <span className={`overlay-success ${this.state.showAddNewBookingOverlay}`}>
                                        <FAIcon icon="check-circle" />
                                    </span>
                                    <Col md={12}>
                                        <h4>
                                            <b>{TR.cPBookings_add_bookings}</b>
                                        </h4>
                                        {this.state.saveError && (
                                            <Col md="12" className="errorMsg">
                                                {TR.cPBookings_save_error}
                                            </Col>
                                        )}
                                        <TableBoxForNewParticipant onClickSave={this.saveNewParticipant} />
                                    </Col>
                                </Row>
                            </>
                        )}

                        <Modal isOpen={this.state.rejectModalOpen}>
                            <ModalHeader>{TR.cPBookings_cancel_participant}</ModalHeader>
                            <ModalBody>
                                Stornogrund:&nbsp;&nbsp;
                                <select
                                    value={this.state.rejectOption}
                                    onChange={(e) => {
                                        this.setState({ rejectOption: e.target.value });
                                    }}
                                >
                                    <option value="teilnehmer">{TR.cPBookings_participant_storno}</option>
                                    <option value="kursanbieter">{TR.cPBookings_course_provider_storno}</option>
                                    <option value="teilstorno">{TR.cPBookings_partial_storno}</option>
                                </select>
                                {this.state.rejectOption === 'teilstorno' && (
                                    <>
                                        <br />
                                        <br />
                                        <h4>{TR.cPBookings_partial_storno2}</h4>
                                        {TR.cPBookings_changed_booking_price}&nbsp;&nbsp;
                                        <input
                                            type="text"
                                            maxLength={6}
                                            value={this.state.rejectPrice}
                                            onChange={(e) => {
                                                this.setState({ rejectPrice: ('' + e.target.value).replace('-', '') });
                                            }}
                                        />
                                    </>
                                )}
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    onClick={() => {
                                        this.setState({ rejectModalOpen: false });
                                    }}
                                >
                                    {TR.cPBookings_cancel}
                                </Button>
                                <Button
                                    onClick={() => {
                                        if (this.state.rejectBooking) {
                                            this.rejectBooking(this.state.rejectBooking);
                                        }
                                    }}
                                >
                                    {TR.cPBookings_save}
                                </Button>
                            </ModalFooter>
                        </Modal>
                    </Container>
                )}
                <Footer />
            </NetworkOverlay>
        );
    }

    private formatNumber = (n: number) => {
        return n.toLocaleString('de-DE', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
            useGrouping: false,
        });
    };

    private saveDataCalculator = () => {
        const mySaveData: Accounting = this.state.saveData;
        let feeSum: number = 0;
        let priceSum: number = 0;
        let appointments: number = 0;
        let bookings: number = 0;
        this.state.saveData.CourseBookings.map((cb: CourseBookings) => {
            appointments++;
            cb.Bookings.map((b: Booking) => {
                bookings++;
                if (!b.Rejected) {
                    feeSum += b.CommissionFee;
                    priceSum += b.BookingOptionPrice;
                } else if (b.Rejected && b.Reason === 'Teilstorno') {
                    feeSum += b.CommissionFee;
                    priceSum += b.BookingOptionPrice;
                }
            });
        });
        mySaveData.Sum = priceSum;
        mySaveData.CommissionSum = feeSum;
        mySaveData.Appointments = appointments;
        mySaveData.Bookings = bookings;

        this.setState(
            {
                commissionSum: feeSum,
                loading: false,
                saveData: Object.assign(this.state.saveData, mySaveData),
                sum: priceSum,
            },
            () => {
                this.forceUpdate();
            }
        );
    };

    private openRejectModal = (b: Booking) => {
        this.setState({ rejectModalOpen: true, rejectBooking: b });
    };

    private rejectBooking = (b: Booking) => {
        const price = Number(this.state.rejectPrice.replace(',', '.'));
        if (this.state.rejectOption === 'teilstorno' && (isNaN(price) || price > 5000 || price === 0)) {
            return;
        }

        ApiBookingsReject(
            {
                ID: b.ID,
                Booking: b,
                Reason: this.state.rejectOption,
                NewPrice: price,
            },
            (sr) => {
                if (sr.OK && sr.Data) {
                    b.Rejected = sr.Data.Rejected;
                    b.Reason = sr.Data.Reason;
                    b.CommissionFee = sr.Data.CommissionFee;
                    b.BookingOptionPrice = sr.Data.BookingOptionPrice;
                    this.setState({ rejectModalOpen: false, rejectBooking: undefined, rejectPrice: '' });
                }
                this.changeValue('Month', this.state.searchParams.Month, true);
            }
        );
    };
    private unrejectBooking = (b: Booking) => {
        ApiBookingsUnreject({ ID: b.ID }, (sr) => {
            if (sr.OK && sr.Data) {
                b.Rejected = sr.Data.Rejected;
                b.Reason = sr.Data.Reason;
                b.CommissionFee = sr.Data.CommissionFee;
                b.BookingOptionPrice = sr.Data.BookingOptionPrice;
            }
            this.changeValue('Month', this.state.searchParams.Month, true);
        });
    };

    private changeBookingOption = (b: Booking, bo: BookingOption) => {
        ApiBookingsChangeOption({ ID: b.ID, BookingOption: bo }, (sr) => {
            if (sr.OK && sr.Data) {
                b.BookingOptionName = sr.Data.BookingOptionName;
            }
            this.changeValue('Month', this.state.searchParams.Month, true);
        });
    };

    private saveNewParticipant = (a: Booking) => {
        this.setState({ loading: true, saveError: false }, () => {
            const mySaveData: Accounting = this.state.saveData;
            let myBookingObject: BookingCreateParams = {
                Bookings: [
                    {
                        Appointment: a.Appointment,
                        BookingOptionName: a.BookingOptionName,
                        BookingOptionPrice: a.BookingOptionPrice,
                        City: '',
                        CourseId: a.CourseID,
                        CourseName: a.CourseName,
                        CourseProviderId: mySaveData.CourseProviderID,
                        CourseProviderName: mySaveData.CourseProviderName,
                        Email: a.Email,
                        FirstName: a.FirstName,
                        LastName: a.LastName,
                        Lecturer: '',
                        Note: TR.cPBookings_added_by_course_provider,
                        Street: '',
                        Telephone: a.Telephone,
                        Zip: '',
                    },
                ],
                ManualEntry: true,
            };
            mySaveData.CourseBookings.map((cb: CourseBookings) => {
                cb.Bookings.map((b: Booking) => {
                    if (
                        myBookingObject.Bookings[0].CourseId === b.CourseID &&
                        moment(myBookingObject.Bookings[0].Appointment).format('DD.MM.YYYY').toString() ===
                            moment(b.Appointment).format('DD.MM.YYYY').toString()
                    ) {
                        myBookingObject = Object.assign(myBookingObject, { Lecturer: b.Lecturer });
                    }
                });
            });

            let newCourseBookings: CourseBookings = {
                Bookings: [],
                CourseDate: a.Appointment,
                CourseID: a.CourseID,
                CourseName: a.CourseName,
            };
            ApiBookingsAdd({ ...myBookingObject }, (sr) => {
                if (sr.OK && sr.Data) {
                    newCourseBookings = Object.assign(newCourseBookings, { Bookings: sr.Data.Bookings });
                    let weHaveSameAppointment: boolean = false;
                    const startDateBooking = a.Appointment;
                    mySaveData.CourseBookings.map((cb: CourseBookings, index: number) => {
                        if (
                            newCourseBookings.CourseID === cb.CourseID &&
                            moment(startDateBooking).format('DD.MM.YYYY').toString() ===
                                moment(cb.CourseDate).format('DD.MM.YYYY').toString()
                        ) {
                            mySaveData.CourseBookings[index].Bookings.push(newCourseBookings.Bookings[0]);
                            weHaveSameAppointment = true;
                        }
                    });
                    if (!weHaveSameAppointment) {
                        const tMonth = moment(a.Appointment).format('YYYY-MM').toString();
                        if (tMonth === this.state.searchParams.Month) {
                            mySaveData.CourseBookings.push(newCourseBookings);
                        }
                    }
                    this.setState(
                        {
                            saveData: Object.assign(this.state.saveData, mySaveData),
                            showAddNewBookingOverlay: 'overlay-show',
                        },
                        () => {
                            this.saveDataCalculator();
                            setTimeout(() => {
                                this.setState({ showAddNewBookingOverlay: '' });
                            }, 1000);
                        }
                    );
                } else {
                    this.setState({ serverResponse: sr, loading: false, saveError: true });
                }
            });
        });
    };

    // private getInvoiceState = (myStatus: string) => {
    //     let newStatus: string = '';
    //     if (myStatus === InvoiceState.Invoiced) {
    //         newStatus = '(abgerechnet)';
    //     }
    //     return newStatus;
    // };

    private changeValue = (fieldName: string, value: string | boolean | number, reload: boolean = false) => {
        const newParams = { ...this.state.searchParams };
        newParams[fieldName] = value;
        if (reload) {
            this.setState({ searchParams: newParams }, () => {
                this.getBookingRequests();
            });
        } else {
            this.setState({ searchParams: newParams });
        }
    };

    private getBookingOptions = (id: string) => {
        let myBookingOptionArray: BookingOption[] = [];
        this.state.coursesMinimal.Courses.map((cm: CourseMinimal) => {
            if (cm.ID === id) {
                myBookingOptionArray = cm.BookingOptions;
            }
        });
        return myBookingOptionArray;
    };

    private loadCourseLoadMinimal = () => {
        ApiCourseLoadminimal((sr1) => {
            if (sr1.OK && sr1.Data !== null) {
                this.setState({
                    coursesMinimal: sr1.Data ? sr1.Data : this.state.coursesMinimal,
                });
            } else {
                this.setState({ serverResponse: sr1 });
            }
        });
    };

    private getBookingRequests = () => {
        this.loadCourseLoadMinimal();
        ApiAccountingLoadmine({ ...this.state.searchParams }, (sr) => {
            if (sr.OK && sr.Data) {
                const acc = this.state.showBookings ? sr.Data.Bookings : sr.Data.Accounted;

                this.setState({
                    commissionSum: acc ? acc.CommissionSum : 0,
                    listData: acc ? acc : this.state.listData,
                    loading: false,
                    saveData: acc ? acc : this.state.saveData,
                    serverResponse: sr,
                    sum: acc ? acc.Sum : 0,
                    weDontHaveData: acc.CourseProviderID === '',
                    saveError: false,
                });
            } else if (sr.Data === null) {
                this.setState({ loading: false, weDontHaveData: true, saveError: false });
            } else {
                this.setState({ serverResponse: sr });
            }
        });
    };
}



// WEBPACK FOOTER //
// ./src/views/cpBookings/CPBookings.tsx